import React from "react";

export type LogoutIconProps = {
  cx?: string;
};

export const LogoutIcon: React.FC<LogoutIconProps> = ({ cx = "" }) => {
  return (
    <svg
      width="22"
      height="22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={cx}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M13.54 13.682v2.851l.003.13.002.064H7.85l-.265.001c-.117.001-.233.002-.35.001v-.016l.002-.105V5.271h5.958c.117-.002.234-.002.35-.002v.001l-.001.105V8.318c0 .332.29.652.632.636.343-.016.632-.28.632-.636V5.562l.002-.169a4.001 4.001 0 0 0-.003-.364c-.023-.278-.125-.547-.335-.736A1.119 1.119 0 0 0 13.735 4h-6.67a1.091 1.091 0 0 0-.796.336c-.19.207-.293.467-.294.749v11.816c.004.292.112.579.322.786.207.205.482.311.771.313H13.737a1.103 1.103 0 0 0 1.074-1.09c.002-.114.002-.228.001-.342V13.679c0-.332-.291-.652-.633-.636-.349.019-.638.283-.638.64zm0 3.146.005-.004-.004.003zm-6.303 0-.003-.003.003.003zm2.517-5.2H17.468l-.91.917-.282.283c-.234.236-.251.668 0 .9.253.235.645.252.895 0l.763-.768 1.217-1.225.28-.283c.06-.06.106-.13.136-.207a.55.55 0 0 0 .05-.253.717.717 0 0 0-.14-.389.651.651 0 0 0-.092-.1l-.716-.72-1.217-1.225-.281-.283c-.234-.235-.664-.253-.895 0-.232.255-.25.65 0 .9l.763.769.41.412H10.89l-.373-.001c-.249-.002-.498-.003-.747 0h-.016c-.33 0-.648.293-.632.637.014.345.277.636.632.636z"
        fill="#111"
        fillOpacity=".8"
      />
    </svg>
  );
};
